import gql from 'graphql-tag';

export const GET_PICKLIST_ITEMS_BY_PICKLIST_IDS = gql`
	query ($ids: [ID]) {
		getPicklistItemsByPicklistIds (ids: $ids) {
			id
			quantity
			extraQuantity
			extraQuantityIsPicked
			isPicked
			planogramItem {
				id
				isIngredient
			}
			pickOrder
			product {
				id
				name
			}
		}
	}
`;



